import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-file-drop',
  templateUrl: './file-drop.component.html',
  styleUrls: ['./file-drop.component.scss']
})
export class FileDropComponent implements OnInit {
  @Input() acceptedFileTypes: string = '.xlsx, .xls, .csv';
  // size is in MB
  @Input() fileSize: number = 10;
  @Output() fileEvent: EventEmitter<FileList> = new EventEmitter<FileList>();
  isDraggingOver: boolean = false;
  constructor(private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  onChange($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.fileEvent.emit(($event.target as HTMLInputElement).files)
  }

  onDragOver($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.isDraggingOver = true;
  }

  onDragLeave($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.isDraggingOver = false;
  }

  onDropSuccess($event: DragEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.isDraggingOver = false;
    if ($event.dataTransfer.files) {
      if (!this.validateFileSize($event.dataTransfer.files[0])) {
        return;
      }
      this.fileEvent.emit($event.dataTransfer.files);
    }
  }

  validateFileSize(file: File): boolean {
    const size = (file.size / (1024*1024));
    if (size > this.fileSize) {
      this._snackBar.open('File size too large', null, { duration: 3000, horizontalPosition: 'start', panelClass: 'snack-error' });
      return false;
    }
    this._snackBar.open('File uploading', null,
      { duration: 3000, horizontalPosition: 'start', panelClass: 'snack-success' });
    return true;
  }

}
